import {
  DAPI_FLAGS,
  callWithDapiFallback,
  dapiGet,
} from "../_core/dapiFallback";
import { apiRequest } from "../_core/apiRequest";
import { getAuthHeaders } from "../_core/authHeaders";

async function getProfileViaLambda() {
  return apiRequest({
    method: "get",
    path: "/profile/info",
    errorMessage: "Erro ao buscar dados da API",
  });
}

async function getProfileViaDapi(idToken) {
  return dapiGet("/v1/profile/info", idToken);
}

export async function getProfile() {
  const { Client_ID: idToken } = await getAuthHeaders();

  return callWithDapiFallback(
    DAPI_FLAGS.profile,
    () => getProfileViaDapi(idToken),
    () => getProfileViaLambda()
  );
}
